<router-outlet style="width: 100%;"></router-outlet>
<mat-toolbar>
  <mat-toolbar-row class="legal">
    <span class="spacer"></span>
    <p>©2020 Novo Look</p>
    <a mat-button routerLink="legal">aviso legal</a>
  </mat-toolbar-row>
</mat-toolbar>
